import { ComposerMediaContext } from 'components/ComposerMediaContext'
import { PPDrawer } from 'components/PPDrawer'
import { useComposerVideoUpload } from 'hooks/useComposerVideoUpload'
import { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setInstagramCoverUrl, updateComposerVideo, uploadPreview } from 'services/compose'
import { composerInstagramCoverUrlSelector, composerVideoSelector, composerVideoUrlSelector } from 'services/compose/selectors'
import { closeVideoCoverDialog } from 'services/ui'
import { videoCoverDialogSelector } from 'services/ui/selectors'
import { StoreThunkDispatch } from 'store/state'
import VideoCoverDialog from './VideoCoverDialog'

export function VideoCoverDialogHost() {
  const dispatch = useDispatch<StoreThunkDispatch>()
  const { dispatch: contextDispatch } = useContext(ComposerMediaContext)
  const dialog = useSelector(videoCoverDialogSelector)
  const videoUrl = useSelector(composerVideoUrlSelector)
  const videoId = useSelector(composerVideoSelector)?.id
  const coverUrl = useSelector(composerInstagramCoverUrlSelector)
  const videoUpload = useComposerVideoUpload()

  const close = () => {
    dispatch(closeVideoCoverDialog())
  }

  const thumbChosen = async (thumb: string, offset: number | undefined) => {
    const response = await fetch(thumb)
    const blob = await response.blob()
    const file = new File(
      [blob],
      'fileName.jpg',
      {
        type: 'image/jpeg',
        lastModified: Date.now()
      }
    )
    dispatch(uploadPreview(file, videoUrl as string)).subscribe((res: any) => {
      dispatch(updateComposerVideo({
        item: {
          id: videoId as string,
          thumbnailUrl: `${res.url}?v=${Date.now()}`,
          thumbnailOffset: offset
        },
        contextDispatch
      }))
    })
    close()
  }

  // A local upload enables the "pick from video" generator; a URL-sourced video still gets
  // the upload-only dialog (Instagram cover) — VideoCoverDialog handles videoFile: undefined.
  if (!dialog || (!videoUpload?.file && !videoUrl)) {
    return null
  }

  // Without a local file the drawer only offers the Instagram cover upload, so the thumbnail
  // wording would be wrong.
  const title = videoUpload?.file ? 'Select thumbnail' : 'Instagram cover'

  return (
    <PPDrawer open={dialog.open} onClose={close} title={title} size="lg">
      {dialog.open && (
        <VideoCoverDialog
          videoFile={videoUpload?.file}
          initialTab={dialog.tab}
          coverUrl={coverUrl}
          disableClickAway
          onCoverChange={url => dispatch(setInstagramCoverUrl(url))}
          onClose={close}
          onGenerateThumb={thumbChosen}
        />
      )}
    </PPDrawer>
  )
}

export default VideoCoverDialogHost
